import { V2Empty } from '../V2Empty.jsx';
import { useEntity } from '../../lib/useEntity.js';

// Mirrors V2Summary.jsx — defensive string coercion so a non-string slot
// renders empty instead of crashing React (#31). Duplicated until a third
// caller justifies extracting a shared helper (rule-of-three).
function asText(v) {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'boolean') return String(v);
  return '';
}

function CommitRow({ commitment }) {
  const p = commitment?.payload || commitment || {};
  const display = commitment?.display || {};
  const taskURN = p.task_ref || null;
  const { data: taskData } = useEntity(taskURN || '');
  // JOBE-0169: prefer the server-projected display.label (typed,
  // rune-capped, derived from fulfillmentCondition). Fallbacks preserve
  // legacy behaviour for memories without a display sidecar.
  const label = asText(display.label) || p.body?.slice(0, 80) || 'Commitment';
  const dueAt = asText(display.subtitle) || p.due_at || taskData?.payload?.due_at || null;
  const status = taskData?.payload?.status || null;
  return (
    <div className="v2-commit-row" data-testid="v2-commit-row">
      <span className="v2-commit-label">{label}</span>
      {dueAt && <span className="v2-commit-due dim">due {dueAt}</span>}
      {status === 'fulfilled' && <span className="v2-commit-badge">fulfilled</span>}
    </div>
  );
}

export function V2Commits({ commitments, loading }) {
  if (loading) return <div className="v2-loading" data-testid="v2-commits-loading">Loading…</div>;
  if (!commitments.length) return <V2Empty message="No commitments recorded for this conversation." />;
  return (
    <div className="v2-commits" data-testid="v2-commits">
      <div className="v2-approx-badge" title="Filtered by time overlap — scope is approximate">approximate scope</div>
      {commitments.map((c, i) => <CommitRow key={i} commitment={c} />)}
    </div>
  );
}
